import {
  MainPurposeConditionOne,
  MainPurposeConditionOther,
  MainPurposeHealthGoalOne,
  MainPurposeHealthGoalOther,
  MainPurposePersonalSignalOne,
  MainPurposePersonalSignalOther,
  MainPurposeProfileFallback,
  MainPurposeProfileFemale,
  MainPurposeProfileMale,
  MainPurposeProfilePerson,
  MainPurposeSublineFeelBest,
  MainPurposeSublineFillGaps,
  MainPurposeSublineFillGapsNoConditions,
  MainPurposeSublineReplaceSupplements,
  MainPurposeSublineSpecificNeeds,
  MainPurposeSublineStopPills,
} from '../Constants';

const MAIN_PURPOSE_SUBLINE_KEYS = {
  feel_best: MainPurposeSublineFeelBest,
  replace_supplements: MainPurposeSublineReplaceSupplements,
  specific_needs: MainPurposeSublineSpecificNeeds,
  fill_gaps: MainPurposeSublineFillGaps,
  stop_pills: MainPurposeSublineStopPills,
};

const getRoundedCount = (value) => {
  const count = Number(value);
  if (!Number.isFinite(count) || count < 0) return 0;
  return Math.round(count);
};

const getCountLabel = (t, count, singularKey, pluralKey) =>
  t(count === 1 ? singularKey : pluralKey, { count });

const getMainPurposeProfilePhrase = (t, context = {}) => {
  const age = Number(context.age);
  const gender = String(context.gender || '')
    .trim()
    .toLowerCase();

  if (!Number.isFinite(age) || age <= 0 || !gender) {
    return t(MainPurposeProfileFallback);
  }

  if (gender === 'male') return t(MainPurposeProfileMale, { age });
  if (gender === 'female') return t(MainPurposeProfileFemale, { age });

  return t(MainPurposeProfilePerson, { age });
};

export const buildMainPurposeSubline = (t, mainPurpose, context) => {
  const sublineKey = MAIN_PURPOSE_SUBLINE_KEYS[mainPurpose];
  if (!sublineKey) return '';

  const ingredientsCount = getRoundedCount(context?.ingredientsCount);
  const focusAreaCount = getRoundedCount(context?.focusAreaCount);
  const personalSignalsCount = getRoundedCount(context?.personalSignalsCount);
  const specialConditionsCount = getRoundedCount(context?.specialConditionsCount);
  const translationKey =
    mainPurpose === 'fill_gaps' && specialConditionsCount === 0
      ? MainPurposeSublineFillGapsNoConditions
      : sublineKey;

  return t(translationKey, {
    ingredientsCount,
    healthGoalsCount: focusAreaCount,
    personalSignalsCount,
    conditionsCount: specialConditionsCount,
    profilePhrase: getMainPurposeProfilePhrase(t, context),
    healthGoalsLabel: getCountLabel(t, focusAreaCount, MainPurposeHealthGoalOne, MainPurposeHealthGoalOther),
    personalSignalsLabel: getCountLabel(
      t,
      personalSignalsCount,
      MainPurposePersonalSignalOne,
      MainPurposePersonalSignalOther,
    ),
    conditionsLabel: getCountLabel(
      t,
      specialConditionsCount,
      MainPurposeConditionOne,
      MainPurposeConditionOther,
    ),
  });
};
